export default "__VITE_ASSET__COvp9BGO__";